import { render } from "./NavbarSave.vue?vue&type=template&id=38c8d4e2"
import script from "./NavbarSave.vue?vue&type=script&lang=js"
export * from "./NavbarSave.vue?vue&type=script&lang=js"
script.render = render

export default script